<template>
  <b-row class="dashboard-indicadores-historico-plazos">
    <b-col cols="12">
      <label class="titulo" v-if="showTitulo">Diferencia de Plazos</label>
      <b-table hover
          responsive="sm" 
          class="registro"
          :busy="tableBusy"
          :items="indicadoresPlazos" 
          :fields="indicadoresPlazosFields">
        <div slot="table-busy" class="text-center">
          <b-spinner class="table-spinner" label="Spinning" />
        </div>
        <template v-slot:cell(plazoObjetivo)="data">
          {{ data.item.plazoObjetivo }}
          <!-- {{ data.item.plazoObjetivo | numero(2, true) }} -->
        </template>
        <template v-slot:cell(plazoActual)="data">
          {{ data.item.plazoActual }}
          <!-- {{ data.item.plazoActual | numero(2, true) }} -->
        </template>
        <!-- <template v-slot:cell(opciones)="data">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template slot="button-content">
              <i class="fa fa-ellipsis-v"></i>
            </template>

            <b-dropdown-item 
                @click.stop="exportarComprobantes(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Comprobantes</b-dropdown-item>
          </b-dropdown>
        </template> -->
      </b-table>
    </b-col>
  </b-row>
</template>

<script>

export default {
  props: {
    showTitulo: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      indicadoresPlazos: [],
      indicadoresPlazosFields: [
        { 
          key: 'indicadorPeriodo',
          label: 'Periodo' 
        },
        { 
          key: 'plazoObjetivo',
          class: 'text-right'
        },
        { 
          key: 'plazoActual',
          label: 'Plazo Real',
          class: 'text-right'
        },
        { 
          key: 'descripcion',
          label: 'Descripción'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        }
      ],

      tableBusy: false
    }
  },
  methods: {
    getIndicadores() {
      this.tableBusy = true;
      this.$store.dispatch('resultadosAdministracion/getIndicadoresDiferenciaPlazosHistorico')
        .then(() => {
          this.indicadoresPlazos = this.$store.getters['resultadosAdministracion/indicadoresDiferenciaPlazosHistorico'];
          this.tableBusy = false;
        });
    },
  }
}
</script>

<style>
</style>